








import { Component, Prop, Vue } from 'vue-property-decorator';

declare var Modernizer: any;

@Component({})
export default class ResponsiveImage extends Vue {
  @Prop({ required: true })
  public url!: string;

  @Prop({ default: 'jpeg' })
  public type!: string;

  @Prop({ default: true })
  public responsive!: boolean;

  // Only applicable if responsive is 'false'
  @Prop({ default: undefined })
  public staticSize?: number;

  @Prop({ default: true })
  public progressive!: boolean;

  @Prop({ default: 'cover' })
  public size!: string;

  @Prop({ default: '' })
  public alt!: string;

  public urlPrefix: string = '';
  public imageName: string = '';
  public thumbLoaded = false;

  private sizes = [320, 640, 940, 1600, 3200];
  private unsupportedSize = 940;
  private thumbSize = 64;

  public mounted() {
    this.createUrlParts();

    if (!this.progressive) {
      this.thumbnailLoaded();
    }
  }

  public thumbnailLoaded() {
    // We want to make sure this is only executed once
    if (this.thumbLoaded) {
      return;
    }
    this.thumbLoaded = true;
    this.createImageElement();
  }

  public getThumbnail() {
    return this.changeExtension(this.getSizeUrl(this.thumbSize), 'jpeg');
  }

  public getSizeString(ext?: string) {
    if (!this.responsive) {
      const url = this.staticSize ? this.getSizeUrl(this.staticSize) : this.url;
      return ext ? this.changeExtension(url, ext) : url;
    }

    return this.sizes
      .map(size => `${this.getSizeUrl(size)} ${size}w`)
      .map(str => (ext ? this.changeExtension(str, ext) : str))
      .join(',');
  }

  public changeExtension(url: string, ext: string) {
    return url.replace(
      this.imageName,
      this.imageName.substr(
        0,
        Math.max(this.imageName.lastIndexOf('.'), 0) || undefined
      ) +
        '.' +
        ext
    );
  }

  private createImageElement() {
    const container = this.$refs.container as any;
    const img = new Image();
    const src = document.createElement('source');

    img.classList.add('full');
    img.onload = () => {
      img.classList.add('loaded');
      this.thumbLoaded = false;
    };
    img.src = this.getSizeUrl(
      (!this.responsive && this.staticSize) || this.unsupportedSize
    );
    img.src = this.changeExtension(img.src, this.type);
    img.srcset = this.getSizeString(this.type);
    img.style.objectFit = this.size;
    img.alt = this.alt;

    src.type = 'image/webp';
    src.srcset = this.getSizeString('webp');

    container.appendChild(src);
    container.appendChild(img);
  }

  private getSizeUrl(size: number) {
    return `${this.urlPrefix}/${size}x${this.imageName}`;
  }

  private createUrlParts() {
    const parser = document.createElement('a');
    parser.href = this.url;

    this.urlPrefix = `${parser.protocol}//${parser.hostname}${
      parser.port ? ':' + parser.port : ''
    }`;
    this.imageName = parser.pathname;
  }
}
